import { IUser } from "@/interfaces/user";

const FREEBIRD_KEY = '__freebird_invite__'

interface FreebirdData {
  invitedUserToken: string;
  fromUser: IUser
}

export const useFreebirdToken = () => {

  const setFreebirdData = (data: FreebirdData) => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(FREEBIRD_KEY, JSON.stringify(data));
  }

  const getFreebirdData = () => {
    if (typeof window === 'undefined') return;
    const data = localStorage.getItem(FREEBIRD_KEY);
    if (data) {
      return JSON.parse(data);
    }
    return {};
  }

  const removeFreebirdData = () => {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(FREEBIRD_KEY);
  }

  return {
    setFreebirdData,
    getFreebirdData,
    removeFreebirdData
  }
}